import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/Services/admin.service';
import { AuthService } from 'src/app/Services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/Services/loader.service';

@Component({
  selector: 'app-change-role',
  templateUrl: './change-role.component.html',
  styleUrls: ['./change-role.component.css']
})
export class ChangeRoleComponent implements OnInit {

  userId;
  roles;
  selectedRole;
  bcid: any;
  kpisCheck: any = [];
  roleName: any;
  user: any;
  bcids: any;
  bclist: any;
  kpilist: any;
  kpisCheck1: any;
  kpisCheck2: any;
  roleId: any;
  roleNamesArr: any;

  constructor(private adminservice: AdminService, public authService: AuthService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private loader: LoaderService) {
    this.router.routeReuseStrategy;
  }

  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get("id");
    this.userfull();
    // this.getBCList();
    this.getKpisList();
    // this.LoadRoles();
  }

  // LoadRoles() {
  //   this.adminservice.GetAssignedUserRoles(this.userId).subscribe((data: any) => {
  //     this.roles = data.result;
  //   })
  // }

  userfull(){
    this.adminservice.GetUserFullInfo(this.userId,0).subscribe((data: any) => {
      this.selectedRole = data.result.roleId;
      this.user = data.result.user;
      this.roleName = this.user.roleName;
      this.kpisCheck1 = data.result.bcKPIsIds;
      this.kpisCheck2 = data.result.kpIsIds;
      this.bcid = data.result.budgetCenterId;
      this.bcids = data.result.budgetCenterIds;
      this.bcChange();
      this.getBCList();
      this.adminservice.GetAssignedUserRoles(this.userId).subscribe((data: any) => {
        this.roles = data.result;
        this.changingRole();
      })
    })
  }

  changingRole(){
    // this.bcid = null;
    // this.kpisCheck = [];

    this.roleNamesArr = this.roles.filter((item) => {
      if (item.roleId == this.selectedRole) {
        return item.roleName;
      }
    })
    this.roleName = this.roleNamesArr[0].roleName;
    this.roleId = this.roleNamesArr[0].roleId;

    if (this.roleName == 'Regional Focal Point') {
      this.getKpisList();
      this.kpisCheck = this.kpisCheck2;
    }
    else if(this.roleName == 'BC Focal Point'){
      this.kpisCheck = this.kpisCheck1;
      this.bcChange();
    }

    if(this.roleName == 'BC Focal Point' || this.roleName == 'BC Manager' || this.roleName == 'KPI Coordinator'){
      this.adminservice.GetUserBudgetCenters(this.roleId).subscribe((data: any) => {
        this.bclist = data.result;
        this.bcids = data.result;
          if(this.bclist.length > 0 && this.roleName == 'BC Focal Point'){
            this.bcid= this.bclist[0].id;
            this.bcChange();
          }
      })
  
    }
  }

  // updateKpi(event, id) {
  //   if (event.target.checked) {
  //     this.kpisCheck.push(id);
  //   }
  //   else {
  //     this.kpisCheck.splice(this.kpisCheck.indexOf(id), 1);
  //   }
  // }

  bcChange() {
    this.getBcKpiList();
  }

  getBcKpiList() {
    if(this.bcid && this.bcid != null)
    {
      this.adminservice.LoadBcKPIsList(this.bcid).subscribe((data: any) => {
        this.kpilist = data.result;
      });  
    }
  }

  getBCList() {
    // this.adminservice.GetMyBudgetCenters().subscribe((data: any) => {
    //   this.bclist = data.result;
    //   if(this.bclist.length > 0){
    //     this.bcid= this.bclist[0].id;
    //     this.bcChange();
    //   }
    // })
    // this.adminservice.LoadBudgetCentersList().subscribe((data: any) => {
    //   this.bclist = data.result;
    //   this.bclist = this.bclist.filter(x => this.bcids.includes(x.id) )
    // })
  }

  getKpisList() {
    this.adminservice.LoadRegionalKPIsList().subscribe((data: any) => {
      this.kpilist = data.result;
    })
  }

  EditRole(){
    this.loader.showLoader();
    this.user.roleId =  parseInt(this.selectedRole);
    this.adminservice.UpdateUserRole(this.user.userId,this.selectedRole).subscribe(
      (data) => {
        this.loader.hideLoader();
        this.toastr.success("Role Updated successfully");
        setTimeout(()=>{
          window.location.reload();
        },3000);
      },
      (err:any) => {
        this.loader.hideLoader();
      });
  }

}
